import React, { useState, useEffect, useContext } from "react";
import {
  BORDER,
  SELECTED_TAB_KEY,
  TOAST_TYPE,
} from "../../constants/Constants";
import TroubleShootingTab from "./TroubleShootingTab";
import {
    TroubleShootingAuditColumns,
  auditInitialState,
  breadCrumbItems,
  calendarStyle,
  getLabelForDateAuditLog,
  searchStyle,
  tabDetails,
} from "./helper/helper";
import loaderContext from "../../context/loader/LoaderContext";
import {  downloadAuditLogsCSVService, getSearchedAuditLogList } from "../../service/AuditLogService";
import { t } from "i18next";
import {
  Calendar,
  PrimaryButton,
  SearchBox,
  TextField,
  TooltipHost,
  defaultCalendarStrings,
} from "@fluentui/react";
import Moment from "moment";
import userContext from "../../context/users/UserContext";
import ListViewV3 from "../../components/ListViewV3/ListViewV3";
import toastContext from "../../context/toast/ToastContext";
import CustomToolTipHost from "../../components/CustomToolTipHost/CustomToolTipHost";

const AuditLogListView = (props) => {
  const {  userActionMenuList,setUserActionMenuList,auditFilterObj,setAuditFilterObj,displayListAppliedFilter,setDisplayListAppliedFilter,filterObj,setFilterObj} = props;
  const [selectedRow, setSelectedRow] = useState(0);
  const { setLoaderRunning, ref } = useContext(loaderContext);
  const { userTimeZone } = useContext(userContext);
  const { showToastv2 } =
  useContext(toastContext);
  const [auditLogList, setAuditLogList] = useState([]);

  const [activeDataQuery,setActiveDataQuery] = useState([]);

  const [paginationObj, setPagination] = useState({
    pageIndex: 0,
    pageSize: 10,
  });
  const [sortObj, setSortObj] = useState({
    sortFieldText: "",
    sortFieldValue: "",
    sortDir: false,
    selected: false,
  });

  const formatDate = (date) => {
      return Moment(date).format('DD-MMM-YYYY');
  }

  const fetchData = async (options) => {
    // let page = options.pageIndex;
    // let pageSize = options.pageSize;
    console.log("--- Fetching Data ----",options);
    let sortParams = "id";
    let sortyByDir = false;

    if (
      options.sortObj.sortFieldValue != undefined &&
      options.sortObj.sortFieldValue.length > 0
    ) {
      sortParams = options.sortObj.sortFieldValue;
      sortyByDir = options.sortObj.sortDir;
    }

    const body = {
      auditLogsSearch: {
        auditAction:
          auditFilterObj.userActionDropdownObj == null
            ? null
            : auditFilterObj.userActionDropdownObj,
        auditLogsFrom:
          auditFilterObj.startDateObj == null
            ? null
            : formatDate(auditFilterObj.startDateObj),
        auditLogsTo:
          auditFilterObj.endDateObj == null
            ? null
            : formatDate(auditFilterObj.endDateObj),
        username:
          auditFilterObj.userNameObj == null || auditFilterObj.userNameObj == ""
            ? null
            : auditFilterObj.userNameObj,
        entityId:
        options.filterObj.filterInput == null || options.filterObj.filterInput == ""
            ? null
            : options.filterObj.filterInput,
        auditLogsPage: options.page,
        pageSize: 50,
      },
    };
    console.log("--- Body ----", body);

    setLoaderRunning(true);
    ref.current.continuousStart();
    try {
      const response = await getSearchedAuditLogList(body);
      let data = null;
      let pageCount = null;
      if (response.status === 200 && response.data.result === "SUCCESS") {
       
        console.log("---- Response ----", response);
        const results = response.data.data.results.searchResults;

        setUserActionMenuList(response.data.data.userActionMenu);
        setAuditLogList(results);

        const pageSize = response.data.data.results.pageSize;
        const totalElement = response.data.data.results.totalRecords;
        data = results;
        pageCount = Math.ceil(totalElement / pageSize);
        setLoaderRunning(false);
        ref.current.complete();
        return {
          rows: data,
          pageCount: pageCount,
        };
      } else {
        setLoaderRunning(false);
        ref.current.complete();
        return {
          rows: data,
          pageCount: pageCount,
        };
      }
    } catch (e) {
      setLoaderRunning(false);
      ref.current.complete();
    }
  };

  const handleUserClick = (row) => {
    console.log("--- This row clicked ----", row);
    setSelectedRow(row.index);
  };

  const filterList = (searchInput) => {
    console.log("--- Filter function TODO ---");
  };

  const handleClearFilter = () => {
    console.log("---- Clear Filter Clicked ----");
    setAuditFilterObj(auditInitialState);
    setDisplayListAppliedFilter([]);
    setPagination(() => {
      const newItem = { ...paginationObj };
      newItem.pageIndex = 0;
      return newItem;
    });

    setTimeout(() => {
      setFilterObj(() => {
        const newItem = { ...filterObj };
        newItem.filterInput = null;
        newItem.filterUpdate = newItem.filterUpdate + 1;
        return newItem;
      });
    }, 100);
  };

  // OLD: const columns = TroubleShootingAuditColumns(null,userTimeZone ? userTimeZone : localStorage.getItem("userTimeZone"));
  const columns = TroubleShootingAuditColumns(null,userTimeZone ? userTimeZone : sessionStorage.getItem("userTimeZone"));


  const removeBadgeFromFilter = (toBeRemoveObj) => {
    console.log("--- Updating RemoveBadgeFromFilter ----", toBeRemoveObj);
    setAuditFilterObj((currentAuditFilterObj) => {
      const updatedAuditFilterObj = { ...currentAuditFilterObj };

      if (updatedAuditFilterObj.hasOwnProperty(toBeRemoveObj.key)) {
        updatedAuditFilterObj[toBeRemoveObj.key] = null;
      } else {
        console.error(
          `Key "${toBeRemoveObj.key}" does not exist in auditInitialState.`
        );
      }
      return updatedAuditFilterObj;
    });

    setDisplayListAppliedFilter((current) =>
      current.filter((item) => item.label !== toBeRemoveObj.label)
    );

    setPagination(() => {
      const newItem = { ...paginationObj };
      newItem.pageIndex = 0;
      return newItem;
    });

    setTimeout(() => {
      setFilterObj(() => {
        const newItem = { ...filterObj };
        newItem.filterUpdate = newItem.filterUpdate + 1;
        return newItem;
      });
    }, 100);
  };

  

  const handleApplyClick = (filterValue) => {
    if(filterValue != undefined)filterValue = filterValue.trim();
    const transformedArray = Object.keys(auditFilterObj)
      .map((key) => ({ key, label: getLabelForDateAuditLog(key,auditFilterObj[key]) }))
      .filter((item) => item.label !== null);
    console.log("--- Handle Apply Click ---", transformedArray);

    setDisplayListAppliedFilter(transformedArray);

    setPagination(() => {
      const newItem = { ...paginationObj };
      newItem.pageIndex = 0;
      return newItem;
    });
    setTimeout(() => {
      setFilterObj(() => {
        const newItem = { ...filterObj };
        if(filterValue != null){
          newItem.filterInput = filterValue;
        }  
        newItem.filterUpdate = newItem.filterUpdate + 1;
        return newItem;
      });
    }, 100);
  };

  useEffect(()=>{
    console.log("Active Query",activeDataQuery)
    if(activeDataQuery != undefined && activeDataQuery.data != undefined){
        setAuditLogList(activeDataQuery?.data?.rows);
    }
  },[activeDataQuery]);

  const downloadAuditCSV = async() => {

    const body = {
      auditLogsSearch: {
        auditAction:
          auditFilterObj.userActionDropdownObj == null
            ? null
            : auditFilterObj.userActionDropdownObj,
        auditLogsFrom:
          auditFilterObj.startDateObj == null
            ? null
            : formatDate(auditFilterObj.startDateObj),
        auditLogsTo:
          auditFilterObj.endDateObj == null
            ? null
            : formatDate(auditFilterObj.endDateObj),
        username:
          auditFilterObj.userNameObj == null || auditFilterObj.userNameObj == ""
            ? null
            : auditFilterObj.userNameObj,
        entityId:
        filterObj.filterInput == null || filterObj.filterInput == ""
            ? null
            : filterObj.filterInput,
        auditLogsPage: 0,
        pageSize: 10,
      },
    };

      try{

        setLoaderRunning(true);
        ref.current.continuousStart();
        console.log("--- Audit Log download started ----");
        const response = await downloadAuditLogsCSVService(body);
        
          if (response.status === 200 && response.data.result === "SUCCESS") {
            setLoaderRunning(false);
            showToastv2(TOAST_TYPE.SUCCESS, t("audit-logs.success-message"));
          }else{
            setLoaderRunning(false);
            showToastv2(TOAST_TYPE.ERROR,t("audit-logs.failure-message"));
          }
      }catch(e){
        setLoaderRunning(false);
        showToastv2(TOAST_TYPE.ERROR,t("audit-logs.failure-message"));
      }
}

  const buttonsTopBar = [{
    key: "1",
    button: 
      <div className="add-button-list-view" onClick={()=>{downloadAuditCSV()}}>
        {/* <AddButton  text={t("supervisor.add-supervisor")} /> */}
        <PrimaryButton
          text={t("button.export-csv")}
          className={"common-default-active-button list-view-top-buttons-styles"}
          disabled={activeDataQuery?.data?.rows?.length > 0 ? false : true}
        />
      </div>
  },
  {
    key: "2",
    button: 
      <div className="add-button-list-view" onClick={()=>{activeDataQuery.refetch()}}>
        {/* <AddButton  text={t("supervisor.add-supervisor")} /> */}
        <PrimaryButton
          iconProps={{
            iconName: "Refresh",
            cursor: "pointer",
          }}
          text={t("button.refresh")}
          className={"common-default-active-button list-view-top-buttons-styles"}
          
        />
      </div>
  }
  ];


  return (
    <>
      <ListViewV3
        buttonsTopBar={buttonsTopBar}
        userTimeZone={userTimeZone}
        sortDropdownOptions={[]}
        showSideBySide = {false}
        fetchData={fetchData}
        columns={columns}
        handleUserClick={handleUserClick}
        filterObj={filterObj}
        setFilterObj={setFilterObj}
        sortObj={sortObj}
        setSortObj={setSortObj}
        setPagination={setPagination}
        paginationObj={paginationObj}
        setActiveDataQuery={setActiveDataQuery}
        uniqueKey={"AuditLog"}
        selectedRow={selectedRow}
        fullLength={true}
        tabHeaderPresent={true}
        placeholder={"Entity Id"}
        selectedRowComponent={
          <SelectedRowComponent
            auditListDetails={auditLogList[selectedRow]}
            displayListAppliedFilter={displayListAppliedFilter}
          />
        }
        enhancedFilter={true}
        showSort={false}
        handleApplyClick={handleApplyClick}
        displayListAppliedFilter={displayListAppliedFilter}
        filterList={filterList}
        handleClearFilter={handleClearFilter}
        removeBadgeFromFilter={removeBadgeFromFilter}
        filterPopUpComponent={
          <FilterPopUpComponent
            userActionMenuList={userActionMenuList}
            auditFilterObj={auditFilterObj}
            setAuditFilterObj={setAuditFilterObj}
          />
        }
        pointer={false}
      />
    </>
  );
};

export default AuditLogListView;

const SelectedRowComponent = ({
  auditListDetails,
  displayListAppliedFilter,
}) => {

    const {getConsistentDateFormat} = useContext(userContext);

  if (auditListDetails == undefined) {
    return (
      displayListAppliedFilter.length === 0 && (
        <>
          <div className="list-view-no-details-found">
            <p className="study-list-no-data-txt"></p>
          </div>
        </>
      )
    );
  }

  return (
    <>
      <div className="tab-section">
        <section className="sectionA">
          <p
            style={{
              fontSize: "20px",
              fontWeight: "600",
              padding: "0px 8px",
              margin: "10px 0px",
            }}
          >
            {t("audit-logs.audit-details")}
          </p>
        </section>
        <div className="ms-Grid" dir="ltr">
          <div className="ms-Grid-row">
            <div className="ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl6">
              <div className="form-heading">{t("user.username")}</div>
              <div className="form-mt-10">{auditListDetails.username}</div>
            </div>
            <div className="ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl6">
              <div className="form-heading">
                {t("audit-logs.audit-time-stamp")}
              </div>
              <div className="form-mt-10">
                {getConsistentDateFormat(auditListDetails.auditTimestamp)}
              </div>
            </div>
          </div>
          <div className="ms-Grid-row" style={{ marginTop: "20px" }}>
            <div className="ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl6">
              <div className="form-heading">{t("audit-logs.new-value")}</div>
              <div className="form-mt-10">
                {auditListDetails.newValue == ""
                  ? "-"
                  : auditListDetails.newValue}
              </div>
            </div>
            <div className="ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl6">
              <div className="form-heading">{t("audit-logs.entity-id")}</div>
              <div className="form-mt-10">
                {!auditListDetails.entityId || auditListDetails.entityId == ""
                  ? "-"
                  : auditListDetails.entityId}
              </div>
            </div>
          </div>
          <div className="ms-Grid-row" style={{ marginTop: "20px" }}>
            <div className="ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl6">
              <div className="form-heading">{t("audit-logs.old-value")}</div>
              <div className="form-mt-10">
                {auditListDetails.oldValue == ""
                  ? "-"
                  : auditListDetails.oldValue}
              </div>
            </div>
            <div className="ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl6">
              <div className="form-heading">{t("audit-logs.ip")}</div>
              <div className="form-mt-10">
                {auditListDetails.remoteIPAddress}
              </div>
            </div>
          </div>
          <div className="ms-Grid-row" style={{ marginTop: "20px" }}>
            <div className="ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl6">
              <div className="form-heading">{t("audit-logs.action")}</div>
              <div className="form-mt-10">{auditListDetails.action}</div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

const FilterPopUpComponent = ({
  userActionMenuList,
  auditFilterObj,
  setAuditFilterObj,
}) => {
  const [storeUserActionMenuList, setStoreUserActionMenuList] =
    useState(userActionMenuList);

  const filterList = (searchInput) => {
    if(searchInput != null && searchInput != undefined)searchInput = searchInput.trim();
    let searchValue = searchInput.toLowerCase();

    if (searchValue !== "") {
      const filteredData = userActionMenuList.filter((item) => {
        return item.toLowerCase().includes(searchValue);
      });
      setStoreUserActionMenuList(filteredData);
    } else {
      // If the search input is empty, revert to the original list
      setStoreUserActionMenuList(userActionMenuList);
    }
  };

  const customToolTipClassName = {
    root: "audit-logs-user-action-text",
  };

  const formattedDate = (date) => {
    return date
      .toLocaleDateString("en-GB", {
        day: "numeric",
        month: "short",
        year: "numeric",
      })
      .replace(/ /g, "-");
  };

  return (
    <div style={{ display: "flex" }}>
      <div className="align-filter-section" style={{ width: "15%" }}>
        <span className="filter-section-text">
          {t("audit-logs.user-action")}
        </span>
        <SearchBox
          placeholder={t("button.search")}
          styles={searchStyle}
          onClear={(ev) => {
            // console.log("Custom onClear Called");
          }}
          onChange={(ev, newValue) => {
            console.log("--- Chaining", newValue);
            filterList(newValue);
          }}
        />
        <div className="modal-scroll study-list-filter-section">
          <ul className="upload-date-ul ">
            {storeUserActionMenuList != undefined &&
              storeUserActionMenuList.length > 0 &&
              Array.from(storeUserActionMenuList).map((item, index) => {
                return (
                  <li
                    onClick={() => {
                      setAuditFilterObj({
                        ...auditFilterObj,
                        userActionDropdownObj: item,
                      });
                    }}
                    className={`upload-date-li ${
                      auditFilterObj.userActionDropdownObj == item
                        ? "study-list-active-li"
                        : ""
                    }`}
                    key={index}
                  >
                    <CustomToolTipHost
                      styles={customToolTipClassName}
                      content={item}
                      id={"tooltip_" + index}
                    >
                      {item}
                    </CustomToolTipHost>
                  </li>
                );
              })}
          </ul>
          {storeUserActionMenuList.length == 0 && (
            <div className="list-popup-no-result-message">
              {t("search-message.no-result")}
            </div>
          )}
        </div>
      </div>
      <div className="filter-section-seperator"></div>
      <div
        className="study-start-date-filter-section align-filter-section"
        style={{ width: "15%" }}
      >
        <span className="filter-section-text">
          {t("audit-logs.audit-from")}
        </span>
        <div className="modal-scroll study-list-filter-section-without-search">
          <ul
            className="upload-date-ul"
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              flexDirection: "column",
            }}
          >
            {/* <DatePicker
                      className={calendarStyles.wrapper}
                      placeholder="dd/mm/yyyy"
                      //value={selectFromDate}
                      // onSelectDate={(data)=>{console.log(data)}
                      allowTextInput={true}
                      openOnClick={false}
                      isMonthPickerVisible={false}
                      isDatePickerVisible={false}
                      formatDate={(date) => date?.toLocaleDateString()}
                      parseDateFromString={parseDateFromString}
                      ariaLabel="Select a date"
                    /> */}
            <Calendar
              showMonthPickerAsOverlay={true}
              placeholder={t("placeholder.select-date")}
              ariaLabel="Select a date"
              // DatePicker uses English strings by default. For localized apps, you must override this prop.
              styles={calendarStyle}
              showGoToToday={false}
              strings={defaultCalendarStrings}
              onSelectDate={(date) =>
                setAuditFilterObj({
                  ...auditFilterObj,
                  startDateObj: formattedDate(date),
                })
              }
            />
          </ul>
        </div>
      </div>

      <div className="filter-section-seperator"></div>
      <div
        className="study-start-date-filter-section align-filter-section"
        style={{ width: "15%" }}
      >
        <span className="filter-section-text">{t("audit-logs.audit-to")}</span>
        <div className="modal-scroll study-list-filter-section-without-search">
          <ul
            className="upload-date-ul"
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              flexDirection: "column",
            }}
          >
            <Calendar
              showMonthPickerAsOverlay={true}
              placeholder={t("placeholder.select-date")}
              ariaLabel="Select a date"
              // DatePicker uses English strings by default. For localized apps, you must override this prop.
              styles={calendarStyle}
              showGoToToday={false}
              //strings={defaultCalendarStrings}
              onSelectDate={(date) =>
                setAuditFilterObj({
                  ...auditFilterObj,
                  endDateObj: formattedDate(date),
                })
              }
            />
          </ul>
        </div>
      </div>
      <div className="filter-section-seperator"></div>
      <div
        className="study-start-date-filter-section align-filter-section"
        style={{ width: "15%" }}
      >
        <span className="filter-section-text">{t("audit-logs.username")}</span>
        <TextField
          name={t("audit-logs.username")}
          placeholder={t("placeholder.search")}
          value={auditFilterObj.userNameObj}
          onChange={(ev) => {
            setAuditFilterObj({
              ...auditFilterObj,
              userNameObj: ev.target.value,
            });
          }}
          styles={{ backgroundColor: "#2e3033" }}
        />
      </div>
    </div>
  );
};
